import React from "react";
import PrismicPage from "./pages/PrismicPage";
import { Switch, Route } from "react-router-dom";

export default function Routes({ loading }) {
  const prismicPage = () => {
    return <PrismicPage loading={loading} />;
  };

  return (
    <Switch>
      <Route exact path="/" render={prismicPage} />
    </Switch>
  );
}
